import dayjs from "dayjs";
import { cnvString2Time } from "../../extensions/utils";

export const applyTimeToDate = (timeValue, docDate) => {
  if (!timeValue) return null;
  const time = dayjs.isDayjs(timeValue) ? timeValue : cnvString2Time(timeValue);
  if (!time) return null;
  const base = docDate ? dayjs(docDate) : dayjs();
  return base.hour(time.hour()).minute(time.minute()).second(time.second()).millisecond(0);
};

export const getRecordBackground = (record) => {
  const clientRecords = (record.cnts || []).filter(i => i.objectVid === 1);
  const now = dayjs();
  const finishAt = record.dateTimeFinish
    ? dayjs(record.dateTimeFinish)
    : (record.finish ? dayjs(record.finish) : null);
  const isExpired = finishAt ? now.isAfter(finishAt) : false;

  const allClientsDidNotCome = clientRecords.length > 0 && clientRecords.every(i => i.used === false);
  const allClientsCameAndLeft = clientRecords.length > 0 && clientRecords.every(i => i.used === true && i.visitFinish);
  const someCame = clientRecords.some(i => i.used === true);
  const someClientsDidNotCome = clientRecords.some(i => i.used === false) && someCame;
  const someoneNotLeft = clientRecords.some(i => i.used === true && !i.visitFinish);

  if (record.deleted) return "gray";
  if (allClientsDidNotCome && isExpired) return "red";
  if (allClientsCameAndLeft) return "#bfbfbf";
  if (someClientsDidNotCome || someoneNotLeft) return "#2f6f00";
  return "#f18408";
};

export const getRecordLabel = (record) => {
  const cnts = record.cnts || [];
  const services = cnts.filter(i => i.objectVid === 2);
  const clients = cnts.filter(i => i.objectVid === 1);
  if (services.length) return services.map(s => s.objectName).filter(Boolean).join(", ");
  if (clients.length) return clients.map(c => c.objectName).filter(Boolean).join(", ");
  return record.comment || record.roomName || record.userName || "Запись";
};

export const getRecordOccupancy = (record) => {
  if (!record.maxClients) return null;
  const clients = (record.cnts || []).filter(i => i.objectVid === 1);
  return `${clients.length}/${record.maxClients}`;
};

export const getPeriodRange = (value, period) => {
  if (period === "week") {
    return { begin: value.startOf("isoWeek"), end: value.endOf("isoWeek") };
  }
  if (period === "month") {
    return {
      begin: value.startOf("month").startOf("isoWeek"),
      end: value.endOf("month").endOf("isoWeek"),
    };
  }
  return { begin: value.startOf("day"), end: value.startOf("day") };
};

export const PERIOD_OPTIONS = [
  { value: "day", label: "День" },
  { value: "week", label: "Неделя" },
  { value: "month", label: "Месяц" },
];
